<template>
  <v-container grid-list-lg>
    <v-layout
      row
      wrap
    >
      <v-card
        max-width="400"
        flat
      >
        <v-card-text>
          <p>
            Liste des projets
          </p>
        </v-card-text>

        <elac-tenants-list @select="select" />
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import ElacTenantsList from '@/components/tenants-list/ElacTenantsList.vue';

export default {
  name: 'Tenants',
  components: { ElacTenantsList },
  methods: {
    select(tenant) {
      this.$router.push({ name: 'map', params: { tenant_id: tenant.id } });
    },
  },
};
</script>
